import { render, staticRenderFns } from "./BindGameAccountDialog.vue?vue&type=template&id=52144c9b"
import script from "./BindGameAccountDialog.vue?vue&type=script&lang=js"
export * from "./BindGameAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./BindGameAccountDialog.vue?vue&type=style&index=0&id=52144c9b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports